import { Alert, Table, Tag, Typography } from 'antd'
import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { platformListAllSites } from '../api'
import type { SiteWithWorkspace } from '../types'

export default function PlatformSitesPage() {
  const [rows, setRows] = useState<SiteWithWorkspace[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    platformListAllSites()
      .then((r) => setRows(r.data))
      .catch((err) => setError(err.message))
      .finally(() => setLoading(false))
  }, [])

  if (error) return <Alert type="error" message={error} showIcon />

  return (
    <div>
      <Typography.Title level={4}>Sites</Typography.Title>
      <Table
        className="pf-data-table"
        rowKey="id"
        loading={loading}
        dataSource={rows}
        sticky
        columns={[
          { title: 'Site Name', dataIndex: 'name', align: 'left' as const },
          {
            title: 'Workspace',
            dataIndex: 'workspace_name',
            render: (name: string, row) => <Link to={`/platform/tenants/${row.workspace_id}`}>{name}</Link>,
          },
          { title: 'Slug', dataIndex: 'slug' },
          { title: 'Status', dataIndex: 'status', render: (s: string) => <Tag>{s}</Tag> },
          { title: 'Default Locale', dataIndex: 'default_locale' },
        ]}
      />
    </div>
  )
}
